<template>
  <div class='home-page'>
    <TitleHomeComponent :controller="controller"/>
    <InfoHomeComponent :controller="controller"/>
    <ConvictionHomeComponent :controller="controller" :convictions='convictions'/>
    <TrainingHomeComponent :controller="controller" :infos='infos' :trainings='trainings'/>
  </div>
</template>

<script>
import TitleHomeComponent from '@/components/home/TitleHomeComponent'
import InfoHomeComponent from '@/components/home/InfoHomeComponent'
import ConvictionHomeComponent from '@/components/home/ConvictionHomeComponent'
import TrainingHomeComponent from '@/components/home/TrainingHomeComponent'

import data from '@/data/fixtures'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { gsap } from 'gsap'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'HomePage',

  metaInfo: {
    title: "Shokunin, les formations de L'Atelier - Sur-mesures, complètes et accessibles",
    meta: [{
      vmid: 'description',
      name: 'description',
      content: "Le centre de formation Shokunin propose des formations dans le domaine du développement web (VueJS, web API, React, Azure, Agilité...). Shokunin a été créé par L'Atelier, un studio développement de produits sur-mesures qui place la qualité du code et la co-création au coeur de ses réalisations."
    }]
  },

  data () {
    return {
      controller: null,
      convictions: data.convictions,
      infos: data.infos,
      trainings: data.trainings
    }
  },

  components: {
    TitleHomeComponent,
    InfoHomeComponent,
    ConvictionHomeComponent,
    TrainingHomeComponent
  },

  destroyed () {
    ScrollTrigger.getAll().forEach(st => st.kill())
  },
  created () {
    window.document.title = "Shokunin, les formations de L'Atelier - Sur-mesures, complètes et accessibles"
  }

}
</script>

<style lang='scss' scoped>

.home-page {
  display: flex;
  flex-direction: column;

  min-height: 100%;
  width: 100%;
  background: linear-gradient(white 0%, #f1f1f1 100%,);
}

</style>
